
import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import InputDate from 'components/input/InputDate';
import InputCheckBox from 'components/input/InputCheckBox';
import Button from 'jsx/elements/buttons/Button';

const CalculatorTerm = ({data, onCalculationClick}) => {
  
    const [termData, setTermData] = useState({calculateTo: null,
                                                    principalsTo: null,
                                                    calledIn: null,
                                                    isBond: null}); 


  useEffect(() => {
    console.log("term package", data);
    let termState = {calculateTo: data.calculateTo,
                     principalsTo: data.principalsTo,
                     calledIn: (data.isBond ? data.bond.calledIn : null),
                     isBond: data.isBond};    
   console.log("state", termState);
    setTermData(termState);
  }, [data]);


  function onClick(){
        if (onCalculationClick){
            onCalculationClick(termData);
        }
  }


  return (
        <div className="gutter-top">
            <div className="grid tight collapse840 gutter-top">
                <div className="col s3of12 ">
                    <div className="form inline">
                        <div className="form-inline">
                            <label>Reikna til</label>                            
                            <InputDate value={termData.calculateTo} onChange={(value)=> setTermData({...termData, calculateTo : value}) }/>                                
                        </div>
                    </div>
                </div>
                <div className="col s3of12 form ">
                    <div className="form-inline">
                        <label>Gjalddagar til</label>
                        <InputDate value={termData.principalsTo} onChange={(value)=>setTermData({...termData, principalsTo : value})} />                               
                    </div>
                </div>
                <div className="col s2of12 form text-right">
                    {termData.isBond && <InputCheckBox name={"cbCalledIn"} label={"Gjaldfellt"} value={termData.calledIn} onChange={ (value) => setTermData({...termData, calledIn : value}) }/>}                    
                </div>
                <div className="col s2of12 form text-right">
                    <div className="button-group no-gutter-bottom">
                        <Button text="Reikna" icon="loop2" color="gray-light" onClick={onClick}></Button>                         
                    </div>
                </div>
            </div>
        </div>

    );
};


CalculatorTerm.propTypes = {
    data: PropTypes.object,
  };
  
export default CalculatorTerm;